export const GET_VAULTS = 'GET_VAULTS';
export const SET_VAULTS = 'SET_VAULTS';

export const GET_LINKED_POOLS = 'GET_LINKED_POOLS';
export const SET_LINKED_POOLS = 'SET_LINKED_POOLS';

export const SET_VAULTS_LOADING_FALSE = 'SET_VAULTS_LOADING_FALSE';
